import { fromJS, List } from 'immutable';
import * as constants from './constants';

const initialState = {
  overlay: false,
  toasts: [],
  downloadErrorReportsCount: 0,
};

const getToastIndex = (state,toastId)=> state.get('toasts').findIndex((toast) =>toast.toastId === toastId);

const getToastPath =  (state,toastId) => {
  const toastIndex = getToastIndex(state,toastId);
  return ['toasts',toastIndex];
};

const updateToast = (state, toast)=>{
  const path = getToastPath(state,toast.toastId);
  return state.setIn([...path, 'percentage'], toast.percentage);
};

const reducer = (state = fromJS(initialState), action) => {
  switch (action.type) {
    case constants.SHOW_OVERLAY:
      return state
        .update('overlay', () => true);
    case constants.HIDE_OVERLAY:
      return state
        .update('overlay', () => false);
    case constants.PUSH_TOAST:
      return state
        .update('toasts', (toasts) => (toasts.push(action.toast)));
    case constants.SET_TOASTS:
      return state
        .setIn(['toasts'], List(action.toasts));
    case constants.REMOVE_TOAST:
      return state
        .update('toasts', (toasts) => (toasts.filter((toast) => toast.toastId !== action.toastId)));
    case constants.INCREMENT_DOWNLOAD_ERROR_REPORTS_COUNT:
      return state
        .set('downloadErrorReportsCount', state.get('downloadErrorReportsCount') + 1);
    case constants.DECREMENT_DOWNLOAD_ERROR_REPORTS_COUNT:
      return state
        .set('downloadErrorReportsCount', state.get('downloadErrorReportsCount') - 1);
    case constants.UPDATE_TOAST:
      return updateToast(state, action.payload);
    default:
      return state;
  }
};

export {
  initialState,
};

export default reducer;
